import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

export type RouteConfigImportParams = {
  work_unit_token: string
  product_type_id?: string | number | null
}

export type RouteConfigImportResponse = {
  inserted: number
  errors: string[]
}

export type RouteConfigListParams = {
  work_unit_token?: string | null
  product_type_id?: string | number | null
}

export type RouteConfigListResponse = {
  status: boolean
  data: Array<{
    id: number
    work_unit_token: string
    work_unit_name: string
    origin: string
    destination: string
    days_of_week: string
    date_start: string
    date_end: string
  }>
  total: number
}

const buildQueryString = (params: Record<string, string | number | null | undefined>) =>
  Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`)
    .join('&')

class RouteConfigServices {
  async importRoutes(
    params: RouteConfigImportParams,
    data: FormData
  ): Promise<RouteConfigImportResponse> {
    try {
      const query = buildQueryString(params)
      const url = `${process.env.REACT_APP_URL_BUSINESS_RULE}/route-config/import${query ? `?${query}` : ''}`
      const response = await axios.post<RouteConfigImportResponse>(url, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRoutes(params: RouteConfigListParams = {}): Promise<RouteConfigListResponse> {
    try {
      const response = await axios.get<RouteConfigListResponse>(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/route-config/list`,
        {
          headers: { 'authentication-token': getJWT()! },
          params,
        }
      )
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async export(params: RouteConfigListParams = {}): Promise<any> {
    try {
      const query = buildQueryString(params)
      const url = `${process.env.REACT_APP_URL_BUSINESS_RULE}/route-config/export${query ? `?${query}` : ''}`
      const response = await axios.get(url, {
        headers: { 'authentication-token': getJWT()! },
      })
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const routeConfigServices = new RouteConfigServices()
